<template>
  <div class="container">
    <div class="mybox">
      <div class="jf">
        <div class="wdjf">我的积分</div>
        <div class="totalpoint">{{ totalPoint }}</div>
      </div>
      <div class="noticebox">
        <div class="notice">
          <van-notice-bar left-icon="volume" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="3000"
              :show-indicators="false"
            >
              <div class="text" v-for="(item, index) in list" :key="index">
                <van-swipe-item @click="noticedetail(item)">
                  {{ item.title }}
                </van-swipe-item>
              </div>
            </van-swipe>
          </van-notice-bar>
        </div>
        <button class="orderbutton" @click="toOrder">我的订单</button>
      </div>
    </div>
    <div class="productlist">
      <div class="title">产品精选</div>
      <div class="list">
        <div
          class="detail"
          v-for="(item, index) in prolist"
          :key="index"
          v-show="item.productId != null"
        >
          <div @click="toProduct(item.productId, item.chineseName)">
            <img :src="item.pictureUrl" alt="" />
            <div>{{ item.chineseName }}</div>
            <div>
              <span>{{ item.integralNum }} </span>积分
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { totalPoint, sysNotice, findWashProductList } from "@/api/api";
import { trackEventActive } from "@/matomo";

export default {
  components: {},
  props: {},
  data() {
    return {
      list: [],
      totalPoint: "0",
      prolist: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    async upperFindTotalPoint() {
      //获取总积分
      let params = {
        memberId: this.$cookies.get("memberId"),
      };
      let totalRes = await totalPoint(params);
      if (totalRes.code == "0000") {
        this.totalPoint = totalRes.data;
      }
    },
    async getProductList() {
      //获取总积分
      let params = {
        platform: 33,
      };
      let list = await findWashProductList(params);
      if (list.code == "0000") {
        this.prolist = list.data;
      }
    },
    toProduct(id, chineseName) {
      gio("track", "MPZJ30217", { product_id: id, product_name: chineseName });
      //  this.$matomo.trackEvent('MPZJ30217','MPZJ30217','MPZJ30217','MPZJ30217',{'product_id':id,'product_name':chineseName});
      trackEventActive(this, "MPZJ30217", {
        product_id: id,
        product_name: chineseName,
      });

      this.$router.push({
        path: "/productDetails?sources=11&id=" + id,
      });
    },
    toOrder() {
      gio("track", "MPZJ30216", "##");
      //  this.$matomo.trackEvent('MPZJ30216','MPZJ30216');
      trackEventActive(this, "MPZJ30216", "");
      this.$router.push({
        path: "/order?sources=11",
      });
    },
    // toMine() {
    //    gio('track', 'MPZJ30210','##');
    //   this.$router.push({
    //     path: "/my",
    //   });
    // },
    async getNotice() {
      let params = {
        type: 2,
      };
      const res = await sysNotice(params);
      // console.log(res)
      if (res.code == "0000") {
        this.list = res.data.rows;
      }
    },
    noticedetail(item) {
      this.$router.push({
        path: "/noticedetail",
        query: {
          notice: item,
        },
      });
    },
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.upperFindTotalPoint();
    }, 1000);
    this.getNotice();
    this.getProductList();
  },
};
</script>

<style lang="scss" scoped>
/deep/html,body {
  background-color: #f0f2f5;
}
.container {
  background-color: #f0f2f5;
  border-top: 1px solid #fff;
  .mybox {
    background-color: #f7f6f7;
    margin: 40px;
    padding: 30px;
    padding-bottom: 0;
    .jf {
      border-bottom: 1px dashed #c8c9cc;

      .wdjf {
        font-size: 1.3em;
        color: #333333;
        // font-weight: 600;
      }
      .totalpoint {
        font-weight: bold;
        color: rgba(0, 0, 0, 0.9);
        font-size: 80px;
      }
    }
    .orderbutton {
      color: #666666;
      background-color: #f6f6f6;
      padding: 10px;
      width: 130px;
      border: none;
      border-radius: 50px;
      display: inline-block;
      margin-left: 6%;
      vertical-align: super;
      font-size: 26px;
    }
  }
  .productlist {
    margin: 40px;
    .title {
      font-weight: 500;
      color: #333333;
      line-height: 45px;
      font-size: 32px;
    }
  }
}

/deep/.van-icon .van-icon__image {
  width: 1rem;
}
/deep/ .van-notice-bar {
  background: #f6f6f6;
  color: #333333;
  padding: 0;
}

.notice-swipe {
  height: 40px;
  line-height: 40px;
}

.notice {
  padding: 10px 0;
  width: 72%;
  display: inline-block;
}
.list {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-bottom: 50px;
  .detail {
    width: 48%;

    // display: inline-block;
    img {
      width: 100%;
      height: 300px;
      background-color: #f7f7f6;
    }
    div {
      margin: 10px 0;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      span {
        font-size: 36px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #333333;
      }
    }
  }
}
</style>
